import { isNullOrUndef } from '../../../utils/isNullOrUndef';
import { isNotNullOrUndef } from '../../../utils/isNotNullOrUndef';
export const addElementToDOM = ({ vNode: { _el, parentVNode }, oldEl, prevEl, nextEl, container }) => {
    if (isNullOrUndef(_el)) {
        console.error('Can\'t add element to DOM, element missing');
        return;
    }
    if (isNotNullOrUndef(oldEl)) {
        oldEl.replaceWith(_el);
        return;
    }
    if (isNotNullOrUndef(prevEl)) {
        prevEl.after(_el);
        return;
    }
    if (isNotNullOrUndef(nextEl)) {
        nextEl.before(_el);
        return;
    }
    const containerEl = container ?? parentVNode?._el;
    if (isNotNullOrUndef(containerEl)) {
        containerEl.append(_el);
        return;
    }
    console.error('Can\'t add element to DOM, none of the methods worked');
};
